/**
 * Unsupported-type fallback renderer.
 *
 * Matched last in the registry so it acts as the catch-all when no
 * specific renderer claimed the source — typically binary office formats
 * (.docx, .xlsx, .pptx) or anything else we can't render in-page.
 *
 * Doesn't try to load any content (no fetch) — there's nothing useful
 * to show, and triggering a request just to show a "can't preview"
 * message wastes a round-trip.
 */
import { FileText } from "lucide-react";

import type { FileRendererProps } from "../types";

export function UnsupportedRenderer({ source }: FileRendererProps) {
  return (
    <div className="flex h-full flex-col items-center justify-center text-muted-foreground">
      <FileText className="mb-4 size-12 opacity-50" />
      <p className="text-sm font-medium">
        Preview not available for this file type
      </p>
      {source.capabilities.canDownload && (
        <p className="text-xs mt-2">Click download to view the file</p>
      )}
    </div>
  );
}
